import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Response} from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {

  constructor(private httpClient: HttpClient) { }

  resetPasswordProcessPartOne(email: string) {
    return this.httpClient.get<Response<boolean>>(environment.apiPath + 'PasswordChange/' + email + '/ResetPasswordProcessPartOne');
  }

  resetPasswordProcessPartTwo(token: string) {
    return this.httpClient.get<Response<boolean>>(environment.apiPath + 'PasswordChange/' + token + '/ResetPasswordProcessPartTwo');
  }

  resetPasswordProcessPartThree(token: string, password: string) {
    return this.httpClient.post<Response<boolean>>(environment.apiPath + 'PasswordChange/ResetPasswordProcessPartThree', {token, password});
  }

  updatePasswordWithoutToken(userId: number, password: string) {
    return this.httpClient.post<Response<boolean>>(environment.apiPath + 'PasswordChange/UpdatePasswordWithoutToken', {userId, password});
  }

  resetPasswordByUserId(userId: number) {
    return this.httpClient.get<Response<boolean>>(environment.apiPath + 'PasswordChange/' + userId + '/UserId/ResetPasswordByUserId');
  }
}
